<template>
  <dl :class="brandClasses?.list">
    <div v-for="({ label, value, maxValue, minLabel, maxLabel }, i) in data" :key="i">
      <dt :id="`meter-label-${i}`" :class="brandClasses.label">
        {{ label }}
      </dt>
      <dd>
        <vf-meter
          :aria-labelledby="`meter-label-${i}`"
          aria-valuemin="1"
          :max-label
          :max-value="maxValue ? +maxValue : undefined"
          :min-label
          :value="value ? +value : undefined"
        />
      </dd>
    </div>
  </dl>
</template>

<script lang="ts" setup>
import type { ProductDetailContentScale } from '#types/product'

defineProps<{
  data: ProductDetailContentScale[]
}>()

const { brandClasses } = useAppConfig().components.product.accordions.scale
</script>
